import { render, staticRenderFns } from "./ServiceDialogBox.vue?vue&type=template&id=72a1151e&scoped=true&"
import script from "./ServiceDialogBox.vue?vue&type=script&lang=js&"
export * from "./ServiceDialogBox.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDialogBox.vue?vue&type=style&index=0&id=72a1151e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a1151e",
  null
  
)

export default component.exports